import React, { Component } from 'react';
import PageHeader from '../../components/PageHeader';
import Container from '../../components/Container';
import DispatchList from '../../components/DispatchList';
import Spacer from '../../components/Spacer';

class RTSList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const breadCrumbs = [
      {
        breadcrumbName: 'Packages',
      },
      {
        breadcrumbName: 'RTS',
      },
      {
        breadcrumbName: 'List',
      },
    ];

    const dispatchListColumns = [
      {
        Header: 'Dispatch ID',
        accessor: 'dh_id',
      },
      {
        Header: 'Courier',
        accessor: 'driver',
      },
      {
        Header: 'Status',
        accessor: 'status',
        sortable: false,
      },
      {
        Header: 'Type',
        accessor: 'type',
        sortable: false,
      },
      {
        Header: 'Date',
        accessor: 'dispatch_date',
      },
    ];

    const customFilter = {
      id: 'type',
      value: 'rts',
    };

    return (
      <div className="RTSList">
        <PageHeader title="RTS" routes={breadCrumbs} />
        <Spacer />
        <Container>
          <DispatchList
            hasExport
            dispatchListColumns={dispatchListColumns}
            customFilter={customFilter}
            fetchText="Fetching RTS List. . ."
            urlEndpoint="/rts"
            typeDispatch="rts"
          />
        </Container>
      </div>
    );
  }
}

export default RTSList;
